module.exports = __webpack_public_path__ + "static/media/people.50d65c61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/people.svg
// module id = 143
// module chunks = 0